import React from "react";

const TextAreaInput = ({
  label,
  name,
  value,
  onChange,
  disabled = false,
  isRequired = false,
  rows = 2
}) => {
  return (
    <div className="mb-3">
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {isRequired && <span className="text-red-600 ml-1">*</span>}
      </label>

      <textarea
        name={name}
        value={value}
        onChange={onChange}
        disabled={disabled}
        required={isRequired}
        rows={rows}
        className="mt-1 py-[5px] px-[10px] block w-full border border-gray-200 rounded-md shadow-sm focus:ring-brand-red focus:border-brand-red disabled:bg-gray-100"
      />
    </div>
  );
};

export default TextAreaInput;
